import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CircleIcon from "@mui/icons-material/Circle";

interface DeactivateAccountDialogProps {
  open: boolean;
  onClose: () => void;
  onDeactivate: () => void;
}

const CONSEQUENCES = [
  "Your profile will be hidden from sitters",
  "Upcoming bookings will be cancelled",
  "You won't receive any notifications",
  "Your data will be preserved",
];

const DeactivateAccountDialog: React.FC<DeactivateAccountDialogProps> = ({
  open,
  onClose,
  onDeactivate,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberIcon color="warning" />
        Deactivate Account?
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Your account will be temporarily disabled. You can reactivate anytime by logging back
          in.
        </Typography>
        <Typography variant="body2" fontWeight={600} mb={1}>
          What happens when you deactivate:
        </Typography>
        <List dense disablePadding>
          {CONSEQUENCES.map((item) => (
            <ListItem key={item} disableGutters sx={{ py: 0.25 }}>
              <ListItemIcon sx={{ minWidth: 20 }}>
                <CircleIcon sx={{ fontSize: 6, color: "text.secondary" }} />
              </ListItemIcon>
              <ListItemText
                primary={item}
                primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          onClick={onDeactivate}
          variant="outlined"
          color="warning"
          sx={{ textTransform: "none" }}
        >
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateAccountDialog;
